import BaseController from "niteroi/packages/system/controllers/Base.controller";

/**
 * @namespace niteroi.controller
 */
export default class Main extends BaseController {
    public onInit(): void {
    }
}
